import { indexItems } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600 group-hover:bg-primary-200',
  secondary: 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-200',
  accent: 'bg-accent-100 text-accent-600 group-hover:bg-accent-200',
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-grid-line"></i>
            <span>主题合集</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            主题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            按主题分类浏览糖心视频丰富内容，快速找到你的甜蜜所爱
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-background-200 transition-colors group cursor-pointer"
            >
              <div
                className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors ${colorMap[item.color] || colorMap.primary}`}
              >
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                  {item.desc}
                </p>
              </div>
              <span className="text-xs font-semibold text-primary-500 bg-primary-50 px-2 py-1 rounded-md whitespace-nowrap flex-shrink-0">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}